import { render, staticRenderFns } from "./omInvestigation.vue?vue&type=template&id=194f1eb5"
import script from "./omInvestigation.ts?vue&type=script&lang=js&external"
export * from "./omInvestigation.ts?vue&type=script&lang=js&external"
import style0 from "./omInvestigation.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports